import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Manifesto from "@/components/Manifesto";
import MarqueeBand from "@/components/MarqueeBand";
import MenuSection from "@/components/MenuSection";
import Gallery from "@/components/Gallery";
import Reservation from "@/components/Reservation";
import Footer from "@/components/Footer";
import CartButton from "@/components/CartButton";
import CartDrawer from "@/components/CartDrawer";
import { CartProvider } from "@/contexts/CartContext";

export default function Home() {
  return (
    <CartProvider>
      <main data-testid="home-page" className="relative bg-cafe text-[var(--text)]">
        <Navbar />
        <Hero />
        <Manifesto />
        <MarqueeBand />
        <MenuSection />
        <Gallery />
        <Reservation />
        <Footer />
        <CartButton />
        <CartDrawer />
      </main>
    </CartProvider>
  );
}
